import { h, Host, getElement, } from "@stencil/core";
import { delegateFocus, trapFocus } from "@eventstore-ui/utils";
import { ICON_NAMESPACE } from "../../../icons/namespace";
/**
 * A pop up modal for overlaying information, warnings and confirmations.
 * Traps focus within the modal, and returns focus to previous location when closed.
 * Pair with an [`es-portal`](/components/components/es-portal) to open and close.
 * @part header - The modal header
 * @part body - The modal body
 * @part footer - The modal footer
 * @slot - Places components in the body.
 * @slot header - Places components in the header. Pass a h2 then a h1 for standard styling.
 * @slot footer - Places components in the footer. Pass es-button and es-button-link.
 */
export class Modal {
    constructor() {
        this.header = true;
        this.footer = true;
    }
    componentDidLoad() {
        delegateFocus(getElement(this));
    }
    connectedCallback() {
        this.releaseFocus = trapFocus(getElement(this));
    }
    disconnectedCallback() {
        this.releaseFocus?.();
    }
    onEscape(e) {
        if (e.key !== 'Escape')
            return;
        this.requestClose.emit();
    }
    render() {
        return (h(Host, { key: 'adc4b6eb7e666b3d7b3a230aa229f4bce00a3ec2' }, h("button", { key: 'acaad3a84f48843de45300405bcfb8d4d07ff561', class: 'close', role: 'button', onClick: () => this.requestClose.emit(), "data-skip-focus-delegation": true }, h("es-icon", { key: '0643ef25b14e3873b5709daf6f43eafb81c790da', icon: [ICON_NAMESPACE, 'close'], size: 22 })), this.header && (h("header", { key: 'b45e6331c0094c6d9240eee318c1dfe4b8627238', part: 'header' }, h("slot", { key: 'be88e9d73e6141bfdacc8513d425d364d0d711cb', name: 'header' }))), h("div", { key: '0f5f9d17f8513340b468ced17bdd150ae1e4babc', class: 'body', part: 'body' }, h("slot", { key: 'fac3fe52dbd59bf0db3bf9eb347c146cb30dfc73' })), this.footer && (h("footer", { key: '7c6f6d60b781351da4978f6d2951de81543e2045', part: 'footer' }, h("slot", { key: '5e22db2302bf3ec581cd3aeab57ffa7082ed330c', name: 'footer' })))));
    }
    static get is() { return "es-modal"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-modal.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-modal.css"]
        };
    }
    static get properties() {
        return {
            "header": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If the modal should have a header."
                },
                "attribute": "header",
                "reflect": false,
                "defaultValue": "true"
            },
            "footer": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If the modal should have a footer."
                },
                "attribute": "footer",
                "reflect": false,
                "defaultValue": "true"
            }
        };
    }
    static get events() {
        return [{
                "method": "requestClose",
                "name": "requestClose",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Triggers when the modal requests to be closed."
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "keyup",
                "method": "onEscape",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=es-modal.js.map
